import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const DynamicLangHelmet = () => {
  const { i18n } = useTranslation();

  const getTitle = () => {
    switch (i18n.language) {
      case 'ja':
        return 'HADO EDUCATION 教育の様々なシーンで活用';
      case 'en':
      default:
        return 'HADO EDUCATION - AR Technology for Educational Solutions';
    }
  };

  const getDescription = () => {
    switch (i18n.language) {
      case 'ja':
        return 'AR技術を駆使した体験提供で課題解決のお手伝いをします。性別、年齢差、体格差、運動能力差が出にくいため世界中で子どもたちの自立する"心"を育む取り組みとして採用されています';
      case 'en':
      default:
        return 'Providing solutions through AR technology experiences. Adopted worldwide as an initiative to nurture children\'s independent \'hearts\' because it reduces differences in gender, age, physique, and athletic ability.';
    }
  };

  const getLocale = () => {
    switch (i18n.language) {
      case 'ja':
        return 'ja_JP';
      case 'en':
      default:
        return 'en_US';
    }
  };

  return (
    <Helmet>
      <html lang={i18n.language} />
      <title>{getTitle()}</title>
      <meta property="og:locale" content={getLocale()} />
      <meta property="og:title" content={getTitle()} />
      <meta property="og:description" content={getDescription()} />
    </Helmet>
  );
};

export default DynamicLangHelmet;
